import styled from "styled-components";

const HomeSlogan2 = styled.h1`
text-align: center;
color: #000;
font-weight: 300;
font-size: 40px;
font-family: sans-serif;
padding: 0px;
line-height: 1.5;
`

export default HomeSlogan2
